<template>
    <v-layout column align-center>
        <span> {{ text_apply }} </span>
        <span> {{ text_grant }} </span>
    </v-layout>
</template>

<script>
import { EXPO_MATCHING_DIRECTIONS, initExpoMatching } from "@/assets/variables";
export default {
    props: {
        item: { type: Object, default: initExpoMatching },
    },
    computed: {
        text_apply() {
            switch (this.item.direction) {
                case EXPO_MATCHING_DIRECTIONS.TO_EMPLOYEE.value: {
                    return "기업요청";
                }
                case EXPO_MATCHING_DIRECTIONS.TO_EMPLOYER.value: {
                    return "회원요청";
                }
            }
        },
        text_grant() {
            let text;
            switch (this.item.direction) {
                case EXPO_MATCHING_DIRECTIONS.TO_EMPLOYEE.value: {
                    text = "회원";
                    break;
                }
                case EXPO_MATCHING_DIRECTIONS.TO_EMPLOYER.value: {
                    text = "기업";
                    break;
                }
            }
            switch (this.item.isGranted) {
                case null: {
                    text += "대기";
                    break;
                }
                case true: {
                    text += "승인";
                    break;
                }
                case false: {
                    text += "거부";
                    break;
                }
            }
            return text;
        },
    },
};
</script>

<style>
</style>